import { createBreakpoint } from 'react-use';
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};
const useInternalBreakpoint = createBreakpoint(breakpoints);

function useBreakpoint() {
  const breakpoint = useInternalBreakpoint();
  return Object.keys(breakpoints).reduce((obj, bp) => {
      obj[bp] = breakpoints[breakpoint] >= breakpoints[bp];
      return obj;
  }, {});
}

export default useBreakpoint;
